import { ReactNode } from 'react';
import styled from 'styled-components';
/**
 * Notes on implementation: https://iterable.quip.com/Aa5KA29G6sgD/Basic-Table-React-Architecture
 */

//  THIS IS A WIP. CURRENTLY JUST HOUSING THE TABLE COMPONENTS AS WE BUILD THEM.
const StyledTable = styled.div`
  border-collapse: collapse;
  display: table;
  width: 100%;
`;

type Props = {
  children: ReactNode;
  id?: string;
};

export const Table = ({ children, ...props }: Props) => (
  <StyledTable data-test="table" role="table" {...props}>
    {children}
  </StyledTable>
);
